
import {POLYREAL} from './PolyRealTypes'

export const changePolyReal = polyReal => {
    return {
        type: POLYREAL,
        load: polyReal
    }
}
export const selectNewPolyReal = (polyReal) => {

    return (dispatch) => {
        dispatch(changePolyReal(polyReal))
    }

}